module.exports = __webpack_public_path__ + "static/img/bg1.06383d40.png";